import { useState, useEffect } from "react";
import { ChevronUp } from "lucide-react";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when user is near the bottom of the page
  const toggleVisibility = () => {
    const scrollY = window.scrollY;
    const scrollPosition = scrollY + window.innerHeight;
    const threshold = document.documentElement.scrollHeight - 600;
    // Require the user to have scrolled past the hero before showing
    setIsVisible(scrollY > 600 && scrollPosition >= threshold);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  useEffect(() => {
    toggleVisibility();
    window.addEventListener("scroll", toggleVisibility);
    window.addEventListener("resize", toggleVisibility);
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
      window.removeEventListener("resize", toggleVisibility);
    };
  }, []);

  return (
    <>
      {isVisible && (
        <button
          onClick={scrollToTop}
          className="fixed bottom-[164px] md:bottom-[176px] right-4 sm:right-6 md:right-8 z-[99] p-3 bg-primary/95 hover:bg-primary backdrop-blur-md text-primary-foreground rounded-full shadow-elevated hover:-translate-y-1 hover:shadow-lg transition-all duration-300 animate-fade-in focus:outline-none group"
          aria-label="Scroll to top"
        >
          <ChevronUp className="w-5 h-5 group-hover:-translate-y-1 transition-transform duration-300" strokeWidth={2.5} />
        </button>
      )}
    </>
  );
};

export default ScrollToTop;
